import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, Download } from 'lucide-react';
import { useUpsell } from './UpsellContext';
interface CTAButtonProps {
  className?: string;
  hideMicrocopy?: boolean;
  size?: 'normal' | 'large';
}
export function CTAButton({
  className = '',
  hideMicrocopy = false,
  size = 'normal'
}: CTAButtonProps) {
  const {
    openUpsell
  } = useUpsell();
  const buttonClasses = size === 'large' ? 'w-full max-w-[95%] md:max-w-xl bg-rose-deep text-white font-bold py-5 px-8 rounded-full shadow-premium hover:bg-rose-deep/90 transition-colors text-center text-[16px] md:text-xl tracking-wide border-2 border-white/20' : 'w-full max-w-[90%] md:max-w-md bg-rose-deep text-white font-semibold py-4 px-6 rounded-full shadow-premium hover:bg-rose-deep/90 transition-colors text-center text-[15px] md:text-lg tracking-wide border border-rose-deep/20';
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-66">
      <motion.button type="button" onClick={openUpsell} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={buttonClasses} data-id="element-67">
        QUIERO ACCEDER A LA BIBLIA DEL CROCHET
      </motion.button>

      {!hideMicrocopy && <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] md:text-xs text-dark/60 font-medium" data-id="element-68">
          <span className="flex items-center gap-1" data-id="element-69">
            <Lock className="w-3 h-3" data-id="element-70" /> Pago seguro
          </span>
          <span className="hidden md:inline" data-id="element-71">•</span>
          <span className="flex items-center gap-1" data-id="element-72">
            <Zap className="w-3 h-3" data-id="element-73" /> Acceso inmediato
          </span>
          <span className="hidden md:inline" data-id="element-74">•</span>
          <span className="flex items-center gap-1" data-id="element-75">
            <Download className="w-3 h-3" data-id="element-76" /> Descarga digital
          </span>
        </div>}
    </div>;
}